import { render, staticRenderFns } from "./head.vue?vue&type=template&id=25197a24&scoped=true&"
import script from "./head.vue?vue&type=script&lang=js&"
export * from "./head.vue?vue&type=script&lang=js&"
import style0 from "./head.vue?vue&type=style&index=0&id=25197a24&scoped=true&lang=less&"
import style1 from "./head.vue?vue&type=style&index=1&id=25197a24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25197a24",
  null
  
)

export default component.exports